import makeCrud from '@/store/site/localization/crud'

// Shopier entegrasyonu store'u (iki yönlü ürün + sipariş + ödeme).
//
// Liste ekranları ortak `makeCrud` fabrikasıyla (server-side sayfalama/filtre)
// alt modüllere ayrılır; aksiyonlar kök modüldedir.

const state = () => ({
    dashboard: null,
    settings: null,
})

const actions = {
    // ── Ayarlar / pano / webhook ─────────────────────────────────────────
    async fetchSettings({commit}) {
        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_shopier_setting'))
        const data = res?.data?.data ?? null
        commit('setSettings', data)
        return data
    },
    async saveSettings(_, {data}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_setting'), data)
        return res?.data
    },
    async testConnection() {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_setting_test'))
        return res?.data
    },
    async fetchDashboard({commit}) {
        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_shopier_dashboard'))
        const data = res?.data?.data ?? null
        commit('setDashboard', data)
        return data
    },
    async registerWebhooks() {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_webhook') + '/register')
        return res?.data
    },
    async oauthAuthorize() {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_oauth') + '/authorize')
        return res?.data
    },
    async oauthDisconnect() {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_oauth') + '/disconnect')
        return res?.data
    },
    async unregisterWebhooks() {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_webhook') + '/unregister')
        return res?.data
    },

    // ── Ürünler ──────────────────────────────────────────────────────────
    async importProducts(_, {ids = [], all = false, includeStock = false, force = false}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_product') + '/import', {
            ids, all, include_stock: includeStock, force,
        })
        return res?.data
    },
    async importStatus() {
        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_shopier_product') + '/import/status')
        return res?.data?.data ?? null
    },
    async pushProducts(_, {productIds, fields = null}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_product') + '/push', {
            product_ids: productIds, fields,
        })
        return res?.data
    },
    async previewProduct(_, {productId}) {
        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_shopier_product') + '/preview/' + productId)
        return res?.data
    },
    async pullProduct(_, {id, includeStock = false}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_product') + '/' + id + '/pull', {include_stock: includeStock})
        return res?.data
    },
    async linkProduct(_, {productId, shopierProductId}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_product') + '/link', {
            product_id: productId, shopier_product_id: shopierProductId,
        })
        return res?.data
    },
    async unlinkProduct(_, {id, deleteRemote = false}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_product') + '/' + id + '/unlink', {delete_remote: deleteRemote})
        return res?.data
    },

    // ── Siparişler ───────────────────────────────────────────────────────
    async syncOrders(_, {days = 7} = {}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_order') + '/sync', {days})
        return res?.data
    },
    async importOrder(_, {id}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_order') + '/' + id + '/import')
        return res?.data
    },
    async fulfillOrder(_, {id}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_order') + '/' + id + '/fulfill')
        return res?.data
    },
    async ignoreOrder(_, {id}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_order') + '/' + id + '/ignore')
        return res?.data
    },

    // ── Loglar ───────────────────────────────────────────────────────────
    async pruneLogs(_, {days = 30} = {}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_log') + '/prune', {days})
        return res?.data
    },
    async retryWebhookEvent(_, {id}) {
        const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_shopier_webhook_event') + '/' + id + '/retry')
        return res?.data
    },
}

const mutations = {
    setDashboard(state, data) {
        state.dashboard = data
    },
    setSettings(state, data) {
        state.settings = data
    },
}

export default {
    namespaced: true,
    state,
    getters: {},
    actions,
    mutations,
    modules: {
        product: makeCrud('ecommerce_shopier_product'),
        remote: makeCrud('ecommerce_shopier_product_remote'),
        candidate: makeCrud('ecommerce_shopier_product_candidate'),
        order: makeCrud('ecommerce_shopier_order'),
        log: makeCrud('ecommerce_shopier_log'),
        webhookEvent: makeCrud('ecommerce_shopier_webhook_event'),
    },
}
